import { matchesRequester } from './changeRequester';
import type { RequesterSource } from './changeRequester';

export type TriageTextFilters = {
    requester?: string;
    title?: string;
    ticketNumber?: string;
};

export type TriageTextFilterRow = RequesterSource & {
    ticket_number?: string;
    title?: { [lang: string]: string } | string;
    localizedTitle?: (language: string) => string | null;
};

function titlesOf(item: TriageTextFilterRow, language: string): string[] {
    const titles: string[] = [];
    if (typeof item.localizedTitle === 'function') {
        const localized = item.localizedTitle(language);
        if (localized)
            titles.push(localized);
    }
    if (item.title && typeof item.title === 'object') {
        Object.values(item.title).forEach((value) => {
            if (value)
                titles.push(String(value));
        });
    } else if (item.title) {
        titles.push(String(item.title));
    }
    return titles;
}

export function hasActiveTriageTextFilters(filters: TriageTextFilters): boolean {
    return Boolean(
        filters.requester?.trim()
        || filters.title?.trim()
        || filters.ticketNumber?.trim()
    );
}

/** Client-side triage match for requester, subject (title), and RT ticket number. */
export function matchTriageTextFilters(
    item: TriageTextFilterRow,
    filters: TriageTextFilters,
    language: string
): boolean {
    if (filters.requester?.trim() && !matchesRequester(item, filters.requester))
        return false;

    const titleNeedle = filters.title?.trim().toLowerCase() || '';
    if (titleNeedle) {
        const titles = titlesOf(item, language).map((value) => value.toLowerCase());
        if (!titles.some((title) => title.includes(titleNeedle)))
            return false;
    }

    const ticketNeedle = filters.ticketNumber?.trim().toLowerCase() || '';
    if (ticketNeedle) {
        const ticketNumber = String(item.ticket_number || '').toLowerCase();
        if (!ticketNumber.includes(ticketNeedle))
            return false;
    }

    return true;
}
